import { createAction } from '@reduxjs/toolkit'

export const AuthActions = {
  setToken: createAction<string>('AUTH_SET_TOKEN'),
  logout: createAction('AUTH_LOGOUT'),
  // fetchAuth не смог проверить токен: сеть/бэк недоступны. Это не RESET_AUTH —
  // юзер не гость, мы просто не знаем; токен и стейт остаются как были
  unavailable: createAction('AUTH_UNAVAILABLE'),
}
